module.exports = __webpack_public_path__ + "media/images/raffstore-9fbc49cff2bed074b8ed45dc91a54acb.jpg";